import { useCallback } from "react";

import { useUpdateWebPushSubscription } from "@/user/services";
import { urlBase64ToUint8Array } from "@/utils/helper";
import { logError } from "@/utils/logger";

export function useUpdatePushSubscription() {
  const { mutate } = useUpdateWebPushSubscription();

  return useCallback(() => {
    if (!import.meta.env.VITE_VAPID_PUBLIC_KEY) {
      return;
    }
    navigator.serviceWorker?.ready.then(function (serviceWorkerRegistration) {
      serviceWorkerRegistration.pushManager
        .subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(
            import.meta.env.VITE_VAPID_PUBLIC_KEY!,
          ),
        })
        .then(function (subscription) {
          mutate(subscription);
        })
        .catch(function (e) {
          logError(e);
        });
    });
  }, [mutate]);
}
